<template>
  <div class="row">
    <div class="col-lg-12">
      <button type="button" class="btn btn-sm btn-danger" @click="deleteApplication()">{{ $t('buttons.deleteEntry') }}</button>
      <router-link :to="{ name: 'ApplicationList', query: {p: currentPage} }" class="btn btn-default btn-sm float-right mb-2">{{$t('buttons.backToList')}}</router-link>
    </div>
    <div class="col-lg-12">
      <div class="card">
        <div v-if="isLoading">
          <Loader></Loader>
        </div>
        <div v-else>
          <div class="card-body">
            <ApplicationForm
              v-if="item"
              :handle-submit="onSendForm"
              :handle-update-field="updateField"
              :values="item"
              :generate-connection-key="generateConnectionKey"
              :errors="violations"
              :initial-values="retrieved" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ApplicationForm from './Form.vue'
import Loader from '../../../Layout/Loader'

export default {
  components: {
    Loader,
    ApplicationForm
  },

  data () {
    return {
      item: {}
    }
  },

  computed: {
    ...mapGetters({
      isLoading: 'application/update/isLoading',
      error: 'application/update/error',
      deleteError: 'application/del/error',
      deleteLoading: 'application/del/isLoading',
      created: 'application/create/created',
      deleted: 'application/del/deleted',
      retrieved: 'application/update/retrieved',
      updated: 'application/update/updated',
      violations: 'application/update/violations',
      currentPage: 'application/list/currentPage'
    })
  },

  watch: {
    // eslint-disable-next-line object-shorthand,func-names
    deleted: function (deleted) {
      if (!deleted) {
        return
      }

      this.$router.push({ name: 'ApplicationList' })
    }
  },

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      createReset: 'application/create/reset',
      deleteItem: 'application/del/del',
      delReset: 'application/del/reset',
      retrieve: 'application/update/retrieve',
      updateReset: 'application/update/reset',
      update: 'application/update/update',
      updateRetrieved: 'application/update/updateRetrieved'
    }),

    generateConnectionKey (bytes = 20) {
      let crypto = require('crypto')
      this.retrieved.connectionKey = crypto.randomBytes(bytes).toString('hex')
    },

    del () {
      if (window.confirm('Are you sure you want to delete this application ?')) {
        this.deleteItem(this.retrieved)
      }
    },
    deleteApplication () {
      this.$Swal({
        title: this.$t('notifications.deleteTitle') + ' ' + this.$t('notifications.deleteApplicationDescription'),
        type: 'question',
        showConfirmButton: true,
        confirmButtonText: this.$t('buttons.yes'),
        showCancelButton: true,
        cancelButtonText: this.$t('buttons.cancel')
      }).then((result) => {
        if (result) {
          this.deleteItem(this.retrieved)
          this.$Swal({
            title: this.$t('notifications.deletedTitle'),
            type: 'success'
          })
        }
      })
    },
    reset () {
      this.updateReset()
      this.delReset()
      this.createReset()
    },

    onSendForm () {
      this.update()
    },

    updateField (field, value) {
      this.updateRetrieved({ [field]: value })
    }
  }
}
</script>
